
class SectionController

    ### @ngInject ###
    constructor: ($scope, moment) ->
        @scope = $scope
        @quarterStart = moment().startOf('quarter')

    Object.defineProperties @prototype,

        name: get: -> @config.name
        toggleData: get: -> @grantReport.section_toggles[@name]
        sectionData: get: -> @grantReport[@name]
        noChangeVerified: get: -> @scope.dybForm?.verify?.activeData
        showItems:
            get: ->
                @config.toggle != "user" or @scope.dybForm?.toggle?.activeData

    noChanges: ->
        item for item in @config.items when @actualIssue(item)

    actualIssue: (item) ->
        if item.type != 'metric' then return false
        actual = @scope.dybForm[item.name]?.actual
        if not actual? then return false
        return not actual.hasChanged and
            @sectionData[item.name].last_verified.isBefore(@quarterStart, 'day')


    save: (data) ->
        @saveCallback(data: data)



sectionDirective = ->
    'ngInject'
    restrict: 'A'
    templateUrl: 'programs/initiatives/amcGrantReportSection'
    controller: SectionController
    controllerAs: 'ctrl'
    scope: {}
    bindToController:
        config: '=amcGrantReportSection'
        grantReport: '='
        saveCallback: '&save'
        afterSave: '&'
        editable: '='

module.directive('amcGrantReportSection', sectionDirective)